/**
 * Price Match Guarantee — product page modal
 * Stores: Shopify contact form + Klaviyo list/event
 */
(function () {
  'use strict';

  function init() {
    var modal = document.getElementById('bcsPriceMatchModal');
    if (!modal) return;

    var overlay = document.getElementById('bcsPriceMatchOverlay');
    var form = modal.querySelector('form');
    var formView = document.getElementById('bcsPriceMatchFormView');
    var successView = document.getElementById('bcsPriceMatchSuccess');
    var errorEl = document.getElementById('bcsPriceMatchError');
    var submitBtn = document.getElementById('bcsPriceMatchSubmit');
    var closeBtn = document.getElementById('bcsPriceMatchClose');
    var doneBtn = document.getElementById('bcsPriceMatchDone');
    var bodyField = document.getElementById('bcsPmBody');
    var urlField = document.getElementById('bcsPmUrl');
    var priceField = document.getElementById('bcsPmPrice');
    var notesField = document.getElementById('bcsPmNotes');

    if (!form || !overlay || !submitBtn || !bodyField) return;

    var KLAVIYO_LIST_ID = 'WJH8Bm';
    var KLAVIYO_COMPANY_ID = 'T22AZL';

    var productData = {
      productTitle: modal.getAttribute('data-product-title') || '',
      productUrl: modal.getAttribute('data-product-url') || '',
      ourPrice: modal.getAttribute('data-our-price') || '',
      variantId: modal.getAttribute('data-variant-id') || ''
    };

    var lastFocus = null;

    function openModal() {
      lastFocus = document.activeElement;
      overlay.hidden = false;
      overlay.setAttribute('aria-hidden', 'false');
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      overlay.classList.add('is-visible');
      modal.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
      var first = form.querySelector('input:not([type="hidden"])');
      if (first) first.focus();
    }

    function closeModal() {
      overlay.classList.remove('is-visible');
      modal.classList.remove('is-visible');
      document.body.style.overflow = '';
      overlay.hidden = true;
      overlay.setAttribute('aria-hidden', 'true');
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function showError(msg) {
      errorEl.textContent = msg;
      errorEl.hidden = false;
    }

    function clearError() {
      errorEl.textContent = '';
      errorEl.hidden = true;
    }

    function showSuccess() {
      formView.hidden = true;
      successView.hidden = false;
    }

    function isValidEmail(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    function isValidUrl(url) {
      try {
        var parsed = new URL(url);
        return parsed.protocol === 'http:' || parsed.protocol === 'https:';
      } catch (e) {
        return false;
      }
    }

    function buildMessageBody(name, email, url, price, notes) {
      var lines = [
        'Price Match Guarantee Request',
        '',
        'Product: ' + productData.productTitle,
        'Product URL: ' + productData.productUrl,
        'Our price: ' + productData.ourPrice,
        'Competitor URL: ' + url,
        'Competitor price: £' + price,
        '',
        'Customer: ' + name,
        'Email: ' + email
      ];

      if (notes) {
        lines.push('', 'Additional notes:', notes);
      }

      return lines.join('\n');
    }

    function getFormAction() {
      var action = form.getAttribute('action') || '/contact';
      return action.split('#')[0];
    }

    function submitShopifyContact() {
      var formData = new FormData(form);

      return fetch(getFormAction(), {
        method: 'POST',
        body: formData,
        credentials: 'same-origin',
        redirect: 'manual'
      }).then(function (res) {
        if (res.ok || res.status === 302 || res.status === 303) {
          return true;
        }
        throw new Error('shopify_failed');
      });
    }

    function subscribeKlaviyo(email, name, competitorUrl, competitorPrice, notes) {
      var parts = (name || '').trim().split(/\s+/);
      var firstName = parts[0] || '';
      var lastName = parts.slice(1).join(' ') || '';

      var profileAttrs = {
        email: email,
        properties: {
          price_match_source: 'Product Page',
          last_price_match_product: productData.productTitle
        }
      };

      if (firstName) profileAttrs.first_name = firstName;
      if (lastName) profileAttrs.last_name = lastName;

      var subscribePromise = fetch(
        'https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY_ID,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            revision: '2024-10-15'
          },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Price Match Guarantee',
                profile: {
                  data: {
                    type: 'profile',
                    attributes: profileAttrs
                  }
                }
              },
              relationships: {
                list: { data: { type: 'list', id: KLAVIYO_LIST_ID } }
              }
            }
          })
        }
      ).then(function (res) {
        if (res.ok || res.status === 202) return true;
        throw new Error('klaviyo_failed');
      });

      fetch('https://a.klaviyo.com/client/events/?company_id=' + KLAVIYO_COMPANY_ID, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          revision: '2024-10-15'
        },
        body: JSON.stringify({
          data: {
            type: 'event',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: { email: email, first_name: firstName, last_name: lastName }
                }
              },
              metric: {
                data: {
                  type: 'metric',
                  attributes: { name: 'Price Match Request' }
                }
              },
              properties: {
                product_title: productData.productTitle,
                product_url: productData.productUrl,
                our_price: productData.ourPrice,
                competitor_url: competitorUrl,
                competitor_price: competitorPrice,
                notes: notes,
                variant_id: productData.variantId
              }
            }
          }
        })
      }).catch(function () { /* non-blocking */ });

      return subscribePromise;
    }

    function handleSubmit() {
      clearError();

      var nameEl = form.querySelector('[name="contact[name]"]');
      var emailEl = form.querySelector('[name="contact[email]"]');

      var name = nameEl ? nameEl.value.trim() : '';
      var email = emailEl ? emailEl.value.trim() : '';
      var url = urlField ? urlField.value.trim() : '';
      var price = priceField ? priceField.value.trim() : '';
      var notes = notesField ? notesField.value.trim() : '';

      if (!name) {
        showError('Please enter your name.');
        return;
      }
      if (!email || !isValidEmail(email)) {
        showError('Please enter a valid email address.');
        return;
      }
      if (!url || !isValidUrl(url)) {
        showError('Please enter a valid link starting with http:// or https://');
        return;
      }
      if (!price) {
        showError('Please enter the price you found.');
        return;
      }

      bodyField.value = buildMessageBody(name, email, url, price, notes);

      submitBtn.disabled = true;
      submitBtn.textContent = 'Sending…';

      var shopifyPromise = submitShopifyContact().catch(function () {
        return false;
      });

      var klaviyoPromise = subscribeKlaviyo(email, name, url, price, notes).catch(function () {
        return false;
      });

      Promise.all([shopifyPromise, klaviyoPromise]).then(function (results) {
        var shopifyOk = results[0] === true;
        var klaviyoOk = results[1] === true;

        if (shopifyOk || klaviyoOk) {
          showSuccess();
          return;
        }

        showError('Could not send your request. Please try again or call us on 0121 553 7872.');
        submitBtn.disabled = false;
        submitBtn.textContent = 'Submit price match request';
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopPropagation();
      handleSubmit();
    });

    submitBtn.addEventListener('click', handleSubmit);

    document.querySelectorAll('[data-price-match-open]').forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        openModal();
      });
    });

    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    if (doneBtn) doneBtn.addEventListener('click', closeModal);
    overlay.addEventListener('click', closeModal);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-visible')) {
        closeModal();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
